import React from "react";

const ClientIcon = ({color, backgroundColor}) => {
  return (
    <>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="28" height="28" rx="14" fill={backgroundColor} fill-opacity="1" />
        <g clip-path="url(#clip0_24612_261076)">
          <path
            d="M17.6605 19.5984C17.6605 18.3613 16.0218 17.3584 14.0003 17.3584C11.9789 17.3584 10.3402 18.3613 10.3402 19.5984M20.5886 17.3587C20.5886 16.4402 19.6852 15.6507 18.3925 15.3051M7.41211 17.3587C7.41211 16.4402 8.3155 15.6507 9.60819 15.3051M18.3925 12.3081C18.8417 11.8979 19.1245 11.3019 19.1245 10.6384C19.1245 9.40132 18.1413 8.39844 16.9284 8.39844C16.366 8.39844 15.853 8.61411 15.4644 8.96881M9.60819 12.3081C9.15891 11.8979 8.87616 11.3019 8.87616 10.6384C8.87616 9.40132 9.85938 8.39844 11.0722 8.39844C11.6347 8.39844 12.1478 8.61411 12.5363 8.96881M14.0003 15.1184C12.7874 15.1184 11.8043 14.1156 11.8043 12.8784C11.8043 11.6413 12.7874 10.6384 14.0003 10.6384C15.2132 10.6384 16.1964 11.6413 16.1964 12.8784C16.1964 14.1156 15.2132 15.1184 14.0003 15.1184Z"
            stroke={color}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_24612_261076">
            <rect width="16" height="14" fill="white" transform="translate(6 7)" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default ClientIcon;
